/**
 * @file: 渲染层板放置区域
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../../UIToolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import * as Toolkit from '../../../toolkit/index';
import FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config/index';

const defaultWidth: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultWidth'
});
const defaultLayerHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
});
const defaultModuleHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultModuleHeight'
});

// 渲染层板放置区域
export function renderDropArea(cube: CubeNode): void {
    let parentCubeId: CubeId = CubeTree.findParentIdByCubeId(cube.id);
    let moduleHeight: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleHeight');
    let moduleWidth: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleWidth');

    // 立式货架层板
    if (CubeTree.isShelf(parentCubeId) && moduleWidth <= 0) {
        moduleWidth = FrontCubeData.getLogicValue(parentCubeId, 'width');
    }

    if (CubeTree.isSketchpad(parentCubeId) && moduleWidth <= 0) {
        moduleWidth = Toolkit.cmToPx(defaultWidth);
    }

    if (moduleHeight <= 0) {
        moduleHeight = Toolkit.cmToPx(defaultModuleHeight);
    }

    cube.jView.find('.' + cube.dslot).css({
        width: moduleWidth,
        height: 0,
        bottom: moduleHeight
    });
}
